/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_WarehousingInputs */

const en_setup_warehousing = /** @type {(inputs: Setup_WarehousingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehousing`)
};

/**
* | output |
* | --- |
* | "Warehousing" |
*
* @param {Setup_WarehousingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_warehousing = /** @type {((inputs?: Setup_WarehousingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_WarehousingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_warehousing(inputs)
});